import { type FC, useEffect } from 'react';
import { useDispatch, useSelector } from '@team/steps-core';
import { slice } from '../slice';
import { rendered } from '../events';

export const Initializer: FC<WithChildren> = ({ children }) => {
  const isInited = useSelector(slice.selectors.isInited);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(rendered());
  }, [dispatch]);

  if (!isInited) {
    return null;
  }

  return children;
};

Initializer.displayName = 'SystemInitializer';
